<template>
  <section class="content-organization-header">
    <div class="content-header-toggle">
      <div class="content-header">
        <h1 id="spa-title" class="heading">
          {{ title }}
        </h1>
        <tutorial-link-button
          v-if="hasTutorial"
          :href="tutorialHref"
          classes=""
          :title="tutorialTitle"
        />
        <tour-button
          v-if="hasTour"
          :title="tutorialTitle"
          :guided-tour-id="guidedTourId"
          :tour-id="tourId"
        />
      </div>
      <search-view-toggle
        v-if="showToggle"
        :active="active"
        :active-action="activeAction"
        :filter-url="filterUrl"
        :browse-url="browseUrl"
      />
    </div>

    <search-active-tags
      v-if="showTags"
      :show-filter-collections="showFilterCollections"
      @tag-update="emit('tag-update')"
      @clear-all="emit('clear-all')"
    />
    <template v-else>
      <div class="content-tags">
        <slot name="customContentTags"></slot>
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
import TourButton from '@/components/tours/tour-button.vue'
import TutorialLinkButton from '@/components/buttons/tutorial-link-button.vue'
import SearchViewToggle from '@/components/search/search-view-toggle.vue'
import SearchActiveTags from '@/components/search/search-active-tags.vue'

/** PROPS **/
withDefaults(
  defineProps<{
    title: string
    hasTutorial?: boolean
    tutorialHref?: string
    tutorialTitle?: string
    hasTour?: boolean
    guidedTourId?: string
    tourId?: string
    active?: 'filters' | 'collections'
    activeAction?: 'openFilters' | 'link'
    filterUrl: string
    browseUrl?: string
    showTags?: boolean
    showFilterCollections?: boolean
    showToggle?: boolean
  }>(),
  {
    hasTutorial: false,
    tutorialHref: '',
    tutorialTitle: '',
    hasTour: false,
    guidedTourId: '',
    tourId: '',
    active: 'filters',
    activeAction: 'openFilters',
    browseUrl: '',
    showTags: true,
    showFilterCollections: false,
    showToggle: true,
  },
)

/** EMITS **/
const emit = defineEmits(['tag-update', 'clear-all'])
</script>
